import { useEffect, useRef, useState } from 'react';
import './IndianRupeeInput.css';

type IndianRupeeInputProps = {
  valuePaise: number;
  onChangePaise: (value: number) => void;
  placeholder?: string;
};

const IndianRupeeInput = ({ valuePaise, onChangePaise, placeholder = '0' }: IndianRupeeInputProps) => {
  const [localStr, setLocalStr] = useState<string>(() =>
    !Number.isFinite(valuePaise) || valuePaise === 0 ? '' : String(valuePaise / 100)
  );
  const ownChange = useRef(false);

  useEffect(() => {
    if (ownChange.current) {
      ownChange.current = false;
      return;
    }
    setLocalStr(!Number.isFinite(valuePaise) || valuePaise === 0 ? '' : String(valuePaise / 100));
  }, [valuePaise]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/[^0-9.]/g, '');
    setLocalStr(raw);
    ownChange.current = true;
    if (raw === '' || raw === '.') {
      onChangePaise(0);
      return;
    }
    const parsed = parseFloat(raw);
    if (Number.isFinite(parsed) && parsed >= 0) {
      onChangePaise(Math.round(parsed * 100));
    }
  };

  return (
    <div className="membership-rupee-input">
      <span className="membership-rupee-input__symbol">₹</span>
      <input
        type="text"
        inputMode="decimal"
        className="membership-rupee-input__field"
        value={localStr}
        placeholder={placeholder}
        onChange={handleChange}
      />
    </div>
  );
};

export default IndianRupeeInput;
